import React, {createContext} from "react";

export interface Results {
    exams: {
        polish: number,
        math: number,
        alien: number
    },
    certs: {
        polish: number,
        math: number,
        itemOne: number,
        itemTwo: number
    },
    others: {
        distinction: number,
        volunteer: number
    },
    contests: number[]
}

const ResultsContext = createContext<{results: Results, setResults: React.Dispatch<React.SetStateAction<Results>>} | undefined>(undefined);
export default ResultsContext